import { render, staticRenderFns } from "./sailorDemeanor.vue?vue&type=template&id=eb713d20&scoped=true"
import script from "./sailorDemeanor.vue?vue&type=script&lang=js"
export * from "./sailorDemeanor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb713d20",
  null
  
)

export default component.exports